import { createRoot } from '@wordpress/element';
import { BitesLibrary } from '@components/Library/BitesLibrary';

window.bitelibraryIniated = false;

export const InitBitesLibrary = () => {
  const editorEl =
    document.getElementById('editor') || document.getElementById('site-editor');

  const biteLibraryEl = document.getElementById('bite-library');
  if (biteLibraryEl && !window.bitelibraryIniated) {
    const root = createRoot(biteLibraryEl);
    root.render(<BitesLibrary />);
    window.bitelibraryIniated = true;
  }

  if (editorEl) {
    if (
      !document.getElementById('bite-library-btn') &&
      !document.getElementById('bite-library')
    ) {
      const toolbalEl = editorEl.querySelector('.edit-post-header-toolbar');
      if (toolbalEl instanceof HTMLElement) {
        toolbalEl.insertAdjacentHTML(
          'afterend',
          `<div id='bite-library'></div>`
        );
      }
    }
  }
};

export default { InitBitesLibrary };
